// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2WF9V","col":"CardReaderDesc_col__33OSh","label":"CardReaderDesc_label__3LUYK"};